import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {GroupModel} from "../../models/group.model";

export class GroupsDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private groupsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $groups, private $log) {
  }

  $onInit() {
    this.groupsRef = this.$groups();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.groupsRef.$asyncValues(ids)
        .then((groups: GroupModel[]) => {
          const displayItems = [];
          _.forEach(groups, (g: GroupModel) => {
            displayItems.push({id: g.id, value: g.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get groups', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.groups')
  .component('groupsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./groups-display-list.html').default,
    controller: GroupsDisplayListComponent
  });
